import React, { useEffect, useMemo, useState } from "react";
import GradeSimpleDetail from "./GradeSimpleDetails";
import { Ptag } from "../../../components/fonts";
import { colors } from "../../../theme";
import { formatToRs, formatToRupees } from "../../../utils/utils";

export const maternityOrder = {
  "Delivery Coverage": 1,
  "New Born Cover": 2,
  "Pre/Post Natal Cover": 3,
};

function RenderGradeSummarySwitch({ name, attributeData, grade }) {
  const showMaternityCoverage = useMemo(() => {
    const maternity =
      attributeData &&
      attributeData.attribute_additional_data &&
      attributeData.attribute_additional_data["Delivery Coverage"];
    if (!maternity) return false;
    return Object.keys(maternity).length > 0;
  }, [attributeData]);

  const optionalRenderer = (localName) => {
    switch (localName) {
      case "Sum Insured":
        return (
          <>
            <GradeSimpleDetail title="Sum Insured">
              <Ptag fontSize="14px" marginTop="8px">
                {" "}
                <b>
                  {attributeData.attribute_default &&
                    formatToRs(attributeData.attribute_default)}
                </b>
              </Ptag>
            </GradeSimpleDetail>
            {grade.dependents_covered && (
              <>
                {grade.dependents_covered.dependents_allowed.length > 0 && (
                  <GradeSimpleDetail
                    title="Dependents Covered"
                    text={grade.dependents_covered.dependents_allowed.join(
                      ", "
                    )}
                  />
                )}
                <section className="summary-horizontal-wrapper">
                  {grade.dependents_covered.max_number_children && (
                    <GradeSimpleDetail
                      title="Max No. of Children"
                      text={`${grade.dependents_covered.max_number_children}`}
                    />
                  )}
                  {grade.dependents_covered.children_age_limit.max && (
                    <GradeSimpleDetail title="Children Age Limit">
                      <Ptag fontSize="14px" marginTop="8px">
                        Min Value:{" "}
                        <b>
                          {grade.dependents_covered.children_age_limit.min}{" "}
                          years
                        </b>
                      </Ptag>
                      <Ptag fontSize="14px" marginTop="8px">
                        Max Value:{" "}
                        <b>
                          {grade.dependents_covered.children_age_limit.max}{" "}
                          years
                        </b>
                      </Ptag>
                    </GradeSimpleDetail>
                  )}
                  {grade.dependents_covered.parental_age_limit.max && (
                    <GradeSimpleDetail title="Parent Age Limit">
                      <Ptag fontSize="14px" marginTop="8px">
                        Min Value:{" "}
                        <b>
                          {grade.dependents_covered.parental_age_limit.min}{" "}
                          years
                        </b>
                      </Ptag>
                      <Ptag fontSize="14px" marginTop="8px">
                        Max Value:{" "}
                        <b>
                          {grade.dependents_covered.parental_age_limit.max}{" "}
                          years
                        </b>
                      </Ptag>
                    </GradeSimpleDetail>
                  )}
                </section>
              </>
            )}
          </>
        );
      case "Co Payment":
        const escp =
          attributeData &&
          attributeData.attribute_additional_data &&
          attributeData.attribute_additional_data[
            "For Employee, Spouse and Children"
          ].attribute_default;
        const parent =
          attributeData &&
          attributeData.attribute_additional_data &&
          attributeData.attribute_additional_data["For Parents/In-laws"]
            .attribute_default;
        const escp_max =
          attributeData &&
          attributeData.attribute_additional_data &&
          attributeData.attribute_additional_data[
            "For Employee, Spouse and Children"
          ].attribute_max;
        const parent_max =
          attributeData &&
          attributeData.attribute_additional_data &&
          attributeData.attribute_additional_data["For Parents/In-laws"]
            .attribute_max;
        const escp_min =
          attributeData &&
          attributeData.attribute_additional_data &&
          attributeData.attribute_additional_data[
            "For Employee, Spouse and Children"
          ].attribute_min;
        const parent_min =
          attributeData &&
          attributeData.attribute_additional_data &&
          attributeData.attribute_additional_data["For Parents/In-laws"]
            .attribute_min;
        // const return
        return (
          attributeData &&
          attributeData.attribute_additional_data &&
          attributeData.attribute_additional_data[
            "For Employee, Spouse and Children"
          ] &&
          Object.keys(
            attributeData.attribute_additional_data[
              "For Employee, Spouse and Children"
            ]
          ).length > 0 && (
            <>
              <GradeSimpleDetail title="Co Payment">
                <section style={{ display: "flex", gap: "8rem" }}>
                  {escp && (
                    <div>
                      {console.log({ escp })}
                      <Ptag fontSize="14px" marginTop="8px">
                        Self, Spouse and Children:{" "}
                        <b>{formatToRs(escp, false)}</b>
                      </Ptag>
                      {escp_min && (
                        <Ptag fontSize="14px" marginTop="8px">
                          Min Value: <b>{formatToRs(escp_min, false)}</b>
                        </Ptag>
                      )}
                      {escp_max && (
                        <Ptag fontSize="14px" marginTop="8px">
                          Max Value: <b>{formatToRs(escp_max, false)}</b>
                        </Ptag>
                      )}
                    </div>
                  )}
                  {parent && (
                    <div>
                      <Ptag fontSize="14px" marginTop="8px">
                        Parents/In-Laws: <b>{formatToRs(parent, false)}</b>
                      </Ptag>
                      {parent_min && (
                        <Ptag fontSize="14px" marginTop="8px">
                          Min Value: <b>{formatToRs(parent_min, false)}</b>
                        </Ptag>
                      )}
                      {parent_max && (
                        <Ptag fontSize="14px" marginTop="8px">
                          Max Value: <b>{formatToRs(parent_max, false)}</b>
                        </Ptag>
                      )}
                    </div>
                  )}
                </section>
              </GradeSimpleDetail>
            </>
          )
        );
      case "Disease Wise Sub-limit":
        const data = attributeData.attribute_additional_data;
        console.log({ data });
        return (
          data.length > 0 &&
          Object.keys(data[0]).length > 0 && (
            <GradeSimpleDetail title="Disease Wise Sub-limit">
              <section
                className="grade-summary-inner"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2rem",
                }}
              >
                {data.map((disease, index) => (
                  <section>
                    {disease["Disease Name"] && (
                      <Ptag fontSize="14px" marginBottom="8px">
                        {index + 1}. {disease["Disease Name"]}
                      </Ptag>
                    )}
                    {disease.attribute_default && (
                      <Ptag fontSize="14px" marginBottom="8px">
                        {" "}
                        <b>
                          {formatToRs(disease.attribute_default, false)}
                        </b>
                      </Ptag>
                    )}
                    {disease.attribute_remarks && (
                      <Ptag fontSize="12px">
                        Remarks: <b>{disease.attribute_remarks}</b>
                      </Ptag>
                    )}
                  </section>
                ))}
              </section>
            </GradeSimpleDetail>
          )
        );
      case "Maternity Coverage":
        const attributes =
          attributeData.attribute_additional_data &&
          Object.keys(attributeData.attribute_additional_data);
        return (
          showMaternityCoverage && (
            <GradeSimpleDetail title="Maternity Coverage">
              <section className="grade-summary-inner">
                {attributes &&
                  attributes
                    .sort((a, b) => maternityOrder[a] - maternityOrder[b])
                    .map((value, index) => {
                      const limit =
                        attributeData.attribute_additional_data[value]
                          .attribute_default;
                      const max =
                        attributeData.attribute_additional_data[value]
                          .attribute_max;
                      const min =
                        attributeData.attribute_additional_data[value]
                          .attribute_min;
                      const remark =
                        attributeData.attribute_additional_data[value]
                          .attribute_remarks;
                      return (
                        limit && (
                          <div key={index}>
                            <Ptag
                              fontSize="14px"
                              fontWeight="bold"
                              color={colors.primaryColor}
                              marginTop={index === 0 ? "10px" : "24px"}
                            >
                              {value}
                            </Ptag>
                            {limit && (
                              <Ptag fontSize="14px" marginTop="8px">
                                {" "}
                                <b>{formatToRs(String(limit), false)}</b>
                              </Ptag>
                            )}
                            {min && (
                              <Ptag fontSize="14px" marginTop="8px">
                                Min Value: <b>{formatToRs(min, false)}</b>
                              </Ptag>
                            )}
                            {max && (
                              <Ptag fontSize="14px" marginTop="8px">
                                Max Value: <b>{formatToRs(max, false)}</b>
                              </Ptag>
                            )}
                            {remark && (
                              <Ptag fontSize="12px" marginTop="8px">
                                Remarks: {remark}
                              </Ptag>
                            )}
                          </div>
                        )
                      );
                    })}
              </section>
            </GradeSimpleDetail>
          )
        );
      default:
        const returnValue = attributeData.attribute_default;
        return (
          returnValue && (
            <GradeSimpleDetail title={name}>
              <section>
                {attributeData.attribute_default && (
                  <Ptag fontSize="14px" marginTop="8px">
                    {" "}
                    <b>
                      {formatToRs(attributeData.attribute_default, false)}
                    </b>
                  </Ptag>
                )}
                {attributeData.attribute_min && (
                  <Ptag fontSize="14px" marginTop="8px">
                    Min Value:{" "}
                    <b>{formatToRs(attributeData.attribute_min, false)}</b>
                  </Ptag>
                )}
                {attributeData.attribute_max && (
                  <Ptag fontSize="14px" marginTop="8px">
                    Max Value:{" "}
                    <b>{formatToRs(attributeData.attribute_max, false)}</b>
                  </Ptag>
                )}
                {attributeData.attribute_remarks && (
                  <Ptag fontSize="12px" marginTop="8px" fontWeight="400">
                    Remarks: {attributeData.attribute_remarks}
                  </Ptag>
                )}
              </section>
            </GradeSimpleDetail>
          )
        );
    }
  };
  return <>{optionalRenderer(name)}</>;
}

export default RenderGradeSummarySwitch;
